export const SET_WISHLIST = 'SET_WISHLIST';
export const SET_WISHLIST_LOADING = 'SET_WISHLIST_LOADING';
